export default __webpack_public_path__ + "88c8a4d.png";